import { render } from "./ImpersonationBanner.vue?vue&type=template&id=0fd816f0"
import script from "./ImpersonationBanner.vue?vue&type=script&lang=js"
export * from "./ImpersonationBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__